import { isBringProd, isBringQa, isBringQaFeature, isLocalhost } from '@glow/common'
import { UserAccessKey } from '@glow/entity-types'
import Immutable from 'immutable'
import { shallowEqual, useSelector } from 'react-redux'
import { AppStateType } from './appStateReduxStore'

const userAccess = (state: AppStateType) =>
  state.getIn(['user', 'access'], Immutable.List()) as Immutable.List<UserAccessKey>

export const canShowInvoicePayload = (state: AppStateType): boolean =>
  userAccess(state).includes('FINANCIAL_SHOW_INVOICING_PAYLOAD')

export const canDownloadInvoice = (state: AppStateType): boolean =>
  userAccess(state).includes('FINANCIAL_DOWNLOAD_INVOICE')

export const canCreateCreditNote = (state: AppStateType): boolean => userAccess(state).includes('FINANCIAL_CREDIT_NOTE')

export const canCreateCopyToBillingOrder = (state: AppStateType): boolean =>
  userAccess(state).includes('FINANCIAL_COPY_TO_BILLING_ORDER')

// Only these hosts route /glow-intelligence to a running service; production opens it to super admins first
export const canUseAskGlow = (state: AppStateType): boolean =>
  isBringProd() ? userAccess(state).includes('SUPER_ADMIN') : (isBringQa() && !isBringQaFeature()) || isLocalhost()

export const canViewPrice = (state: AppStateType): boolean => userAccess(state).includes('VIEW_PRICE')

export const canViewBillingOrders = (state: AppStateType): boolean => {
  const access = userAccess(state)
  return access.includes('PLANNER_BILLING_ORDERS_READ') || access.includes('PLANNER_BILLING_ORDERS')
}

export const canEditBillingOrders = (state: AppStateType): boolean =>
  userAccess(state).includes('PLANNER_BILLING_ORDERS')

export const canReinvoice = (state: AppStateType): boolean =>
  userAccess(state).includes('FINANCIAL_REINVOICE_INVOICED_ORDERS')

export const canUseInvoiceActions = (state: AppStateType): boolean =>
  userAccess(state).includes('FINANCIAL_INVOICE_ACTIONS')

export const canRemoveUnitFromDepartment = (state: AppStateType): boolean =>
  userAccess(state).includes('PLANNER_UNITS_REMOVE')

export const useUserPermissions = () => {
  return useSelector(
    (state: AppStateType) => ({
      canShowInvoicePayload: canShowInvoicePayload(state),
      canDownloadInvoice: canDownloadInvoice(state),
      canCreateCreditNote: canCreateCreditNote(state),
      canCreateCopyToBillingOrder: canCreateCopyToBillingOrder(state),
      canViewPrice: canViewPrice(state),
      canViewBillingOrders: canViewBillingOrders(state),
      canEditBillingOrders: canEditBillingOrders(state),
      canReinvoice: canReinvoice(state),
      canUseInvoiceActions: canUseInvoiceActions(state),
      canRemoveUnitFromDepartment: canRemoveUnitFromDepartment(state)
    }),
    shallowEqual
  )
}
